import { IAgencyState } from "agency/model"
import { ACTIONS, IAppActionInitData } from "app/store/actions"
import { Action, Reducer } from "redux"
import { IAgencySetStripeUserId } from "./actions"
import { getDefaultAgencyState } from "./state"

export const agencyReducer: Reducer<IAgencyState, Action> = (
  state: IAgencyState | undefined,
  action: Action
): IAgencyState => {
  if (!state) {
    state = getDefaultAgencyState()
  }
  switch (action.type) {
    case ACTIONS.APP_INIT_DATA: {
      const { agencies } = action as IAppActionInitData
      return {
        ...state,
        agencies
      }
    }

    case ACTIONS.AGENCY_SET_STRIPE_USER_ID: {
      const { agencyId } = action as IAgencySetStripeUserId
      return {
        ...state,
        agencies: state.agencies.map(a => {
          if (a.id !== agencyId) {
            return a
          }
          return { ...a, stripe_user_id: "stripe-user-id-exist-server-side" }
        })
      }
    }

    case ACTIONS.USER_LOGOUT: {
      return getDefaultAgencyState()
    }

    default:
      return state
  }
}
